<footer class="app-footer">

	<div class="app-footer__infos-container container-fluid">
		<div class="app-footer__centered">
			<div class="row">
				<div class="col-lg-5 col-md-6 col-sm-7">
					<section>
						<p class="app-footer__headline mat-body-1" i18n>voestalpine Böhler Welding</p>
						<p class="app-footer__info-content mat-body-2" i18n>Als führendes
							Unternehmen in der Welt des Schweißens mit mehr als 100 Jahren Erfahrung sind wir mit mehr als 50
							Tochterunternehmen und 4.000 Vertriebspartnern weltweit in der Nähe. Durch unser umfassendes
							Produktportfolio, unsere Schweißkompetenz und globale Ausrichtung kennen wir Ihre Bedürfnisse und stellen
							als Gesamtlösungsanbieter die besten Resultate für Ihre anspruchsvollsten Herausforderungen sicher.
							Perfekt miteinander verzahnt und so einzigartig wie Ihr Unternehmen.</p>
					</section>
				</div>

				<div class="col-lg-3 col-md-3 d-none d-md-block">
					<section>
						<p class="app-footer__headline mat-body-1" i18n>Links</p>
						<ul class="app-footer__info-links app-footer__info-content mat-body-2">
							<li><a class="u-link"
										 href="http://www.vabw-service.com/voestalpine/?changeLang=de"
										 i18n-href i18n>Produktsuche</a></li>
							<li><a class="u-link"
										 href="https://www.voestalpine.com/welding/de/Kontakt/Standorte"
										 i18n-href i18n>Kontakt</a></li>
							<li><a class="u-link"
										 href="https://www.voestalpine.com/welding/de/Unternehmen/News"
										 i18n-href i18n>News</a></li>
							<li><a class="u-link"
										 href="https://www.voestalpine.com/welding/de/Unternehmen/Events"
										 i18n-href i18n>Events</a></li>
							<li><a class="u-link"
										 [routerLink]="['static-page', 'imprint']"
										 i18n="@@footer.contact.legalNotice">Impressum</a></li>
							<li><a class="u-link"
										 [routerLink]="['static-page', 'terms-and-conditions']"
										 i18n>AGB</a></li>
							<li><a class="u-link"
										 routerLink="/static-page/privacy/{{language}}" i18n>Datenschutz</a></li>
							<li>
								<a class="u-link" onclick="UC_UI.showSecondLayer(); return false;" i18n>
									Cookie-Einstellungen
								</a>
							</li>
							<li><a class="u-link" target="_blank" rel="noopener noreferrer"
										 href="{{basePath}}/manuals/EQ-Konfigurator_{{language | uppercase}}.pdf" i18n>Bedienungsanleitung</a></li>
						</ul>
					</section>
				</div>

				<div class="col-lg-2 d-none d-lg-block">
					<section class="app-footer__info-tile">
						<p class="app-footer__headline mat-body-1" i18n>voestalpine-Konzern</p>
						<ul class="app-footer__info-links app-footer__info-content mat-body-2">
							<li><a class="u-link"
										 href="https://www.voestalpine.com/"
										 i18n>voestalpine AG</a></li>
							<li><a class="u-link"
										 href="https://www.voestalpine.com/group/de/produkte/"
										 i18n-href i18n>Produkte</a></li>
							<li><a class="u-link"
										 href="https://www.voestalpine.com/blog"
										 i18n>Corporate Blog</a></li>
						</ul>
					</section>
				</div>
				<div class="col-lg-2 col-md-3 col-sm-5 d-none d-sm-block">
					<section>
						<div class="app-footer__socialmedia app-footer__info-content">
							<a class="app-footer__socialmedia-icon app-footer__socialmedia-icon--facebook"
								 i18n-title title="voestalpine Böhler Welding auf Facebook"
								 href="https://www.facebook.com/voestalpineBoehlerWelding/"></a>
							<a class="app-footer__socialmedia-icon app-footer__socialmedia-icon--youtube"
								 i18n-title title="voestalpine Böhler Welding auf Youtube"
								 href="https://www.youtube.com/user/voestalpinewelding"></a>
							<a class="app-footer__socialmedia-icon app-footer__socialmedia-icon--linkedin"
								 i18n-title title="voestalpine Böhler Welding auf LinkedIn"
								 href="https://at.linkedin.com/company/voestalpine-boehler-welding"></a>
							<a class="app-footer__socialmedia-icon app-footer__socialmedia-icon--instagram"
								 i18n-title title="voestalpine Böhler Welding auf Instagram"
								 href="https://www.instagram.com/voestalpine_boehler_welding/"></a>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>

	<div class="app-footer__contact-container container-fluid">
		<div class="app-footer__content app-footer__centered">
			<div class="row">
				<div class="col-xs-12 col-md-12 col-lg-12">
					<span class="app-footer__contact-span mat-body-2">© {{currentYear()}} voestalpine Böhler Welding GmbH</span>
					<ul class="app-footer__contact-span__list">
						<li class="app-footer__contact-span__list__item">
							<a class="u-link" [routerLink]="['static-page', 'imprint']" i18n>Impressum</a>
						</li>
						<li class="app-footer__contact-span__list__item">
							<a class="u-link" [routerLink]="['static-page', 'privacy', language]" i18n>Datenschutz</a>
						</li>
						<li class="app-footer__contact-span__list__item">
							<a class="u-link" [routerLink]="['static-page', 'terms-and-conditions']" i18n>AGB</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</footer>
